import { invokeApi } from "../../bl_libs/invokeApi";

export const notificationList = async () => {
  const requestObj = {
    path: `api/notification`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const markAllAsRead = async () => {
  const requestObj = {
    path: `api/notification/read_all_notifications`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const markNotificationAsRead = async (id) => {
  const requestObj = {
    path: `api/notification/read_notification/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
